__turbopack_context__.v({
  "border": "Button-module__cIG3xa__border",
  "borderHollow": "Button-module__cIG3xa__borderHollow",
  "borderSmall": "Button-module__cIG3xa__borderSmall",
  "button": "Button-module__cIG3xa__button",
  "divider": "Button-module__cIG3xa__divider",
  "icon": "Button-module__cIG3xa__icon",
  "label": "Button-module__cIG3xa__label",
  "leadingIcon": "Button-module__cIG3xa__leadingIcon",
  "pulsing-frame": "Button-module__cIG3xa__pulsing-frame",
  "root": "Button-module__cIG3xa__root",
  "trailingIcon": "Button-module__cIG3xa__trailingIcon",
});
